import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useAppDispatch} from '../../store/hooks';
import {setTitle} from '../../store/header/header.slice';
import Container from '../common/layout/Container';
import LiveDataCards from './live_data_cards';
import NavigationCards from './navigation_cards';
import HistoricalCards from './histroical_cards';

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const {t} = useTranslation('dashboard');

  useEffect(() => {
    dispatch(setTitle(t('pageTitle')));
  }, []);

  return (
    <Container>
      <div className="dashboard">
        <div className="dashboard__container">
          <LiveDataCards />
          <HistoricalCards />
        </div>
        <NavigationCards />
      </div>
    </Container>
  );
};

export default Dashboard;
